export default __webpack_public_path__ + "static/media/programming-1.9818a974.svg";